var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolSplineRoi = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  transform: "translate(5 5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 4a10.12 10.12 0 0 1 6.5-2.5h4M1.5 15.5v-4c.003-2.16.698-4.263 1.984-6"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4,
  cy: 4.5,
  r: 1.5,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17.5,
  cy: 1.5,
  r: 1.5,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.5,
  cy: 17.5,
  r: 1.5,
  strokeLinecap: "round"
})))));
export { SvgToolSplineRoi as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-spline-roi.svg";